import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { PicklistModalComponent } from '../picklist-modal/picklist-modal.component';

@Component({
  selector: 'lib-attribute-search',
  templateUrl: './attribute-search.component.html',
  styleUrl: './attribute-search.component.sass',
  standalone: false
})
export class AttributeSearchComponent {
  @Input() chat!: any;
  @Input() contextId!: string;

  @Output() pickListValues = new EventEmitter<string>();

  @ViewChild('pickListModal')
  pickListModal!: PicklistModalComponent;

  public showPicklist(picklistId: string, attributeName: string) {
    this.pickListModal.launchModal(this.contextId, picklistId, attributeName);
  }

  public emitPickListValues(event: string) {
    this.pickListValues.emit(event);
  }
}
